import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-submitted',
  templateUrl: './form-submitted.component.html',
  styleUrls: ['./form-submitted.component.scss']
})
export class FormSubmittedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
